import React,{useState,useEffect} from 'react'
import portalServices from '../portalServices';
import moment from 'moment';
import { Dialog, DialogContent } from '@mui/material';

function QueueWorkingHours({queue}) {

    const [dialogStatus,setDialogStatus] = useState(false);
    const [queueWorkingHours,setQueueWorkingHours] = useState(null);
    const showWorkingHours = (queue) =>{
        setDialogStatus(true);
        setQueueWorkingHours(null);
        portalServices.getQueueWorkingHoursList(queue.id).then(res=>{
            setQueueWorkingHours(res.data);
        }).catch(error=>{
        })
    }

    const getWeekDayName = (dayNo) =>{
        let weekDays = ["","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"]
        return weekDays[dayNo];
    }
    return (
        <>
            <button className='btn btn-outline-primary mx-2' onClick={()=>showWorkingHours(queue)}>Show Working Hours</button>
            <Dialog
                        open={dialogStatus}
                        keepMounted
                        onClose={()=>setDialogStatus(false)}
                    >
                        <DialogContent>
                            <div className='row'>
                                {queueWorkingHours && 
                                    <div className='col-md-12'>
                                        <table className='table'>
                                            <thead>
                                                <tr>
                                                    <th>Day</th>
                                                    <th>Time</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {queueWorkingHours.map(day=> day.dayStatus == 1 &&
                                                    <tr key={day.dayNo}>
                                                        <td>{ getWeekDayName(day.dayNo)}</td>
                                                        <td>
                                                           <span className='fw-bold'> { moment( moment().format("YYYY-MM-DD")+" "+day.dayStart).format("h:mm A")} </span>
                                                            to 
                                                            <span className='fw-bold'> { moment( moment().format("YYYY-MM-DD")+" "+day.dayEnd).format("h:mm A")} </span>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                }
                                <div className='col-md-12'>
                                    <button className='btn btn-outline-primary' onClick={()=>setDialogStatus(false)} >Close</button>
                                </div>
                            </div>

                            
                        </DialogContent>
                    </Dialog>
        </>
    )
}

export default QueueWorkingHours